import * as React from 'react'
import { useSelector } from 'react-redux'
import * as yup from 'yup'

import { Formik } from 'formik'
import {
  selectUpcomingFollowUps,
  flipCard,
  setSalesTeamsIds,
  setAssigneeIds,
} from '@user/store/dashboard/widgets/upcomingFollowUps/slice'
import { FormFields } from './FormFields'
import { useHandleSubmit, useInitData } from '../../hooks'

const validationSchema = yup.object({
  numDays: yup
    .number()
    .integer('Please enter an integer value.')
    .min(0, 'Please enter a positive value.')
    .max(180, 'Please enter a value less than 180.')
    .required('Please enter a number between 0 and 180.'),
})

export function FormWrapper() {
  const widgetData = useSelector(selectUpcomingFollowUps)
  const { handleUpcomingFollowupsSubmit } = useHandleSubmit({
    flipCard,
    setSalesTeamsIds,
    setAssigneeIds,
  })
  const { initSalesTeams, initOwnersIds, initSalesTeamsIds, initNumDays } =
    useInitData(widgetData)

  return (
    <Formik
      initialValues={{
        assigneeIds: initOwnersIds,
        numDays: initNumDays,
        salesTeamIds: initSalesTeamsIds,
      }}
      onSubmit={handleUpcomingFollowupsSubmit}
      validationSchema={validationSchema}
    >
      <FormFields
        salesTeams={initSalesTeams}
        assigneeIds={widgetData.assigneeIds}
        initData={{
          assigneeIds: initOwnersIds,
          salesTeamIds: initSalesTeamsIds,
        }}
      />
    </Formik>
  )
}
